import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_have_any_of_the_following_safety_measures_in_place_2'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_have_any_of_the_following_safety_measures_in_place_2',
  name: 'Does the facility have any of the following safety measures in place for confined spaces?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'EACH_CONFINED_SPACE_HAS_SIGNS_INDICATING_THEY_ARE_A_CONFINED_SP',
      text: 'Each confined space has signs indicating they are a confined space',
      externalIds: [
        {
          id: 'hs-13--1-1x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'EACH_CONFINED_SPACE_HAS_THE_APPROPRIATE_PROTECTIONS_TO_ENSURE_N',
      text: 'Each confined space has the appropriate protections to ensure no accidental entry',
      externalIds: [
        {
          id: 'hs-13--1-2x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'EACH_CONFINED_SPACE_HAS_AUTHORIZED_ENTRY_ONLY_ACCESS',
      text: 'Each confined space has authorized entry-only access',
      externalIds: [
        {
          id: 'hs-13--1-3x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WORKERS_CONTRACTORS_THAT_ENTER_CONFINED_SPACES_DO_SO_ONLY_WHEN_',
      text: 'Workers/Contractors that enter confined spaces do so only when appropriate measures have been taken to protect them from any physical hazards present',
      externalIds: [
        {
          id: 'hs-13--1-4x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WORKERS_CONTRACTORS_THAT_ENTER_CONFINED_SPACES_DO_SO_WHEN_THE_A',
      text: 'Workers/Contractors that enter confined spaces do so when the atmosphere is safe and the air has been tested when needed',
      externalIds: [
        {
          id: 'hs-13--1-5x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WORKERS_CONTRACTORS_WHO_ENTER_THE_CONFINED_SPACES_KNOW_AND_UNDE',
      text: 'Workers/Contractors who enter the confined spaces know and understand how to do so safely',
      externalIds: [
        {
          id: 'hs-13--1-6x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'RESCUE_EQUIPMENT_READY_FOR_USE_WHEN_A_CONFINED_SPACE_ENTRY_OCCU',
      text: 'Rescue equipment ready for use (when a confined space entry occurs).',
      externalIds: [
        {
          id: 'hs-13--1-7x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'hs-13--1-8x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'EACH_CONFINED_SPACE_HAS_SIGNS_INDICATING_THEY_ARE_A_CONFINED_SP',
                'EACH_CONFINED_SPACE_HAS_THE_APPROPRIATE_PROTECTIONS_TO_ENSURE_N',
                'EACH_CONFINED_SPACE_HAS_AUTHORIZED_ENTRY_ONLY_ACCESS',
                'WORKERS_CONTRACTORS_THAT_ENTER_CONFINED_SPACES_DO_SO_ONLY_WHEN_',
                'WORKERS_CONTRACTORS_THAT_ENTER_CONFINED_SPACES_DO_SO_WHEN_THE_A',
                'WORKERS_CONTRACTORS_WHO_ENTER_THE_CONFINED_SPACES_KNOW_AND_UNDE',
                'RESCUE_EQUIPMENT_READY_FOR_USE_WHEN_A_CONFINED_SPACE_ENTRY_OCCU',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-bui-11',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 14060,
  sectionId: '2.2.9.7',
  impactArea: 'Worker Protection',
  impactAreaId: 'WORKER_PROTECTION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
